/**
 * @flow
 * @relayHash 24f7cc20999c70e6dde505c07bf39fd2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type vocabularyEdit_viewer$ref = any;
export type vocabularyPage_edit_QueryVariables = {|
  id: string
|};
export type vocabularyPage_edit_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: vocabularyEdit_viewer$ref
  |}
|};
export type vocabularyPage_edit_Query = {|
  variables: vocabularyPage_edit_QueryVariables,
  response: vocabularyPage_edit_QueryResponse,
|};
*/


/*
query vocabularyPage_edit_Query(
  $id: ID!
) {
  viewer {
    ...vocabularyEdit_viewer_1Bmzm5
    id
  }
}

fragment vocabularyEdit_viewer_1Bmzm5 on Viewer {
  id
  vocabularyItem(id: $id) {
    id
    name
    value
    description
    canDelete
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "vocabularyPage_edit_Query",
  "id": null,
  "text": "query vocabularyPage_edit_Query(\n  $id: ID!\n) {\n  viewer {\n    ...vocabularyEdit_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment vocabularyEdit_viewer_1Bmzm5 on Viewer {\n  id\n  vocabularyItem(id: $id) {\n    id\n    name\n    value\n    description\n    canDelete\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "vocabularyPage_edit_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "vocabularyEdit_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "vocabularyPage_edit_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vocabularyItem",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID!"
              }
            ],
            "concreteType": "Vocabulary",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "value",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canDelete",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '82ff6ff04f394aa15d070094c6f1b3c4';
module.exports = node;



// WEBPACK FOOTER //
// src/components/vocabulary/__generated__/vocabularyPage_edit_Query.graphql.js